module.exports = __webpack_public_path__ + "img/espion.aaa1965a.png";